export enum TranslationActionTypes {
    SET_TRANSLATIONS = "SET_TRANSLATIONS",
    CLEAR_TRANSLATIONS = "CLEAR_TRANSLATIONS"
}